var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapboxLayer',{attrs:{"name":_vm.name,"beforeLayerName":_vm.beforeLayerName,"geoJSON":_vm.geoJSON,"layers":_vm.layers,"interactivity":_vm.interactivity,"clusterSettings":_vm.clusterSettings}})}
var staticRenderFns = []

export { render, staticRenderFns }